module.exports = "/_next/static/images/81313f776c12ad0975feedfe1afb2d4f-mastercard-promo-hero@3x.jpg";